module.exports = __webpack_public_path__ + "static/media/page_24.c4a25453.jpg";